import { render, staticRenderFns } from "./SalesPosApp.vue?vue&type=template&id=2cd3881b"
import script from "./SalesPosApp.vue?vue&type=script&lang=js"
export * from "./SalesPosApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports